import React from 'react'
import { FaExclamationTriangle, FaSyncAlt } from 'react-icons/fa'

const formatRelative = (timestamp) => {
  if (!timestamp) return 'Never'
  const value = typeof timestamp === 'string' ? new Date(timestamp) : timestamp
  if (Number.isNaN(value?.getTime?.())) return 'Unknown'

  const diffMs = Date.now() - value.getTime()
  if (diffMs < 0) return 'Just now'
  const diffMinutes = Math.floor(diffMs / 1000 / 60)
  if (diffMinutes < 1) return 'Just now'
  if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`
  const diffHours = Math.floor(diffMinutes / 60)
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`
  const diffDays = Math.floor(diffHours / 24)
  return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`
}

const BufferZoneHeader = ({
  totalEvents = 0,
  lastUpdated,
  refreshing = false,
  onRefresh,
  emergencyMode = false,
  onToggleEmergencyMode,
}) => {
  return (
    <header className="rounded-3xl border border-customAccent/30 bg-gradient-to-br from-customSlate via-white to-customSky px-4 py-2 shadow-xl shadow-customAccent/10 dark:border-customSurface dark:from-customSurface dark:via-customSurface dark:to-customSurfaceMuted dark:text-customHeading">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-customInk dark:text-customHeading">
            Buffer Zone
          </h1>
          <p className="mt-1 max-w-2xl text-sm text-customSecondaryText dark:text-customMuted">
            Stage, refine, and push football events to the betting mobile.
          </p>
        </div>
        <div className="flex flex-wrap items-start gap-3 sm:flex-row sm:items-center">
          <div className="flex items-center gap-2 rounded-xl border border-customAccentBlue/20 bg-customAccentBlue/10 px-3 py-1.5 text-xs font-medium text-customAccentBlue dark:border-customAccent/40 dark:bg-customAccent/20 dark:text-customHeading">
            <span className="h-2 w-2 rounded-full bg-customAccentBlue" />
            {totalEvents} buffered events
          </div>
          {!emergencyMode ? (
            <div className="flex flex-col text-[10px] uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
              <span className="font-bold text-customInk dark:text-customHeading">Last sync</span>
              <span className="font-semibold">{formatRelative(lastUpdated)}</span>
            </div>
          ) : null}
          {emergencyMode &&
            <span className="inline-flex items-center gap-2 rounded-xl bg-customOrange/10 px-3 py-1.5 text-xs font-medium text-customOrange dark:bg-customOrange/20 dark:text-customOrange">
              <FaExclamationTriangle className="text-sm" />
              {'Emergency Mode'}
            </span>
          }
          {!emergencyMode ? (
            <button
              type="button"
              onClick={onRefresh}
              disabled={refreshing}
              className="inline-flex items-center gap-2 rounded-xl bg-customAccentBlue px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-customAccentBlue/30 transition hover:bg-customAccentBlue/80 focus:outline-none focus:ring-2 focus:ring-customAccentBlue/40 disabled:cursor-not-allowed disabled:opacity-70 dark:bg-customAccent dark:text-customHeading"
            >
              {refreshing ? (
                <>
                  <span className="h-3 w-3 animate-spin rounded-full border-2 border-white border-t-transparent" />
                  Updating handicaps...
                </>
              ) : (
                <>
                  <FaSyncAlt className="text-sm" />
                  Update handicaps
                </>
              )}
            </button>
          ) : null}
        </div>
      </div>
    </header>
  )
}

export default BufferZoneHeader
